import UnlinkIcon from './icons/UnlinkIcon';

interface UnlinkCardModalProps {
  cardName: string;
  onUnlink: () => void;
  onClose: () => void;
}

export function UnlinkCardModal({ cardName, onUnlink, onClose }: UnlinkCardModalProps) {
  return (
    <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full">
      <div className="flex items-center gap-3 mb-4">
        <span className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center">
          <span className="w-5 h-5">
            <UnlinkIcon />
          </span>
        </span>
        <h3 className="text-xl font-bold text-white">Unlink Card</h3>
      </div>
      <p className="text-gray-300 mb-6">
        Are you sure you want to unlink{' '}
        <span className="text-white font-semibold">&quot;{cardName}&quot;</span> from this card?
      </p>
      <div className="flex justify-end gap-3">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onUnlink}
          className="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg transition-colors"
        >
          Unlink
        </button>
      </div>
    </div>
  );
}
